import { CSSProperties } from 'react';

export const styles: Record<string, CSSProperties> = {
  trainTheFunMobile: {
    paddingBottom: "30px",
  },
  headerSpan: {
    marginTop: "-30px",
    fontWeight: "bold",
  },
  logoContainer: {
    fontFamily: "Fredoka",
    letterSpacing: "2px",
    fontWeight: "700",
    color: "black",
    fontSize: "24px",
    paddingBottom: "5px",
    marginTop: "30px",
  },
  headerTextLogo: {
    maxWidth: "12.37rem",
  },
  trainFunText: {
    whiteSpace: "nowrap",
    fontFamily: "Rubik",
    fontWeight: "500",
    fontSize: "32px",
    color: "#105D7F",
  },
};